// extracted by mini-css-extract-plugin
module.exports = {"h1":"LandingPage_h1__D3uT4"};